import {
  initializeWidgetConfiguration,
  SgWidget,
  WidgetConfigurationProvider,
  WithGlobalCss,
} from "@sgwt-widget/core";
import { h } from "preact";
import { emit, props } from "skatejs";
import { Select } from "../common/components/form-elements";
import { getDdlValuesByAttribute, getDefaultValueByAttribute } from "./helper";
import { IProps } from "./type";

class CprSelectDdl extends SgWidget<IProps> {
  public static is = "cpr-select-ddl";
  public static props = {
    attribute: props.string,
    indicator: props.string,
    userEmail: props.string,
    userSelection: props.object,
  };
  public render(intraprops: IProps) {
    const attribute = intraprops.attribute || "";

    if (
      !this.props.userSelection ||
      !this.props.userSelection[intraprops.attribute]
    ) {
      intraprops.userSelection = { [intraprops.attribute]: [] };
    }

    const intraOnChange = (value: string[]) => {
      if (!value || value[0] === "") {
        value = [];
      }
      const newValue = { [attribute]: value };
      intraprops.userSelection = newValue;
      emit(this, "cpr-select-ddl--filter-changed", { detail: newValue });
    };

    return (
      <WidgetConfigurationProvider
        widgetConfiguration={this.widgetConfiguration}
      >
        <WithGlobalCss>
          <Select
            defaultValue={this.getDefaultValue(intraprops, attribute)}
            onChange={intraOnChange}
            items={this.getItems(attribute)}
          />
        </WithGlobalCss>
      </WidgetConfigurationProvider>
    );
  }

  private getDefaultValue(intraprops: IProps, attribute: string) {
    return getDefaultValueByAttribute(intraprops, attribute);
  }

  private getItems(attribute: string): any[] {
    return getDdlValuesByAttribute(attribute);
  }
}

initializeWidgetConfiguration(CprSelectDdl);
customElements.define(CprSelectDdl.is, CprSelectDdl);
